import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import {
  Modal,
  InfoMessageBlock,
  Messaging,
  MessageItem,
  NoticeView,
} from 'components';
import { useProfile, useTenancy } from 'state';
import styles from './TenancyViewNotices.module.scss';

/**
 * TenancyViewNotices
 *
 * @return {JSX.Element}
 */
const TenancyViewNotices = ({ className }) => {
  const profile = useProfile();
  const tenancyNoticesCollection = useTenancy().notices;
  const {
    mapped: { messagingDataByTenancy, tenancyData, paymentsData },
  } = tenancyNoticesCollection;
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenNotice, setIsOpenNotice] = useState(null);

  const handleCLose = () => {
    setIsOpen(false);
    setIsOpenNotice(false);
  };
  const handleOpenMessenger = () => setIsOpen(true);
  const handleOpenNotice = (data) => () => setIsOpenNotice(data);

  // 0 - because it is filtered for current tenancy, so there is only one item in array
  const messages = messagingDataByTenancy[0];

  const lastGroup = messages.data[messages.data.length - 1];
  const viewMessage = lastGroup.items[lastGroup.items.length - 1].data; // messages && getViewMessage(messages);
  const unread =
    viewMessage &&
    profile.data.profileUid !== viewMessage.messageFromUid &&
    !viewMessage.hasViewed;

  return (
    <div
      className={classNames(
        styles.TenancyViewNotices,
        className,
        TenancyViewNotices.displayName
      )}
    >
      {paymentsData?.length
        ? paymentsData.map((item) => (
            <MessageItem
              className={styles.MessageItem}
              key={item.data.noticeUid}
              message={item.data.messageText}
              type={item.data.noticeType}
              subject={item.data.noticeTitle}
              onClick={handleOpenNotice(item)}
              hasViewed={item.data.hasViewed}
              isImage={item.data.isImage}
              noWrap
            />
          ))
        : null}
      {tenancyData?.length
        ? tenancyData.map((item) => (
            <MessageItem
              className={styles.MessageItem}
              key={item.data.noticeUid}
              message={item.data.messageText}
              type={item.data.noticeType}
              subject={item.data.noticeTitle}
              onClick={handleOpenNotice(item)}
              hasViewed={item.data.hasViewed}
              isImage={item.data.isImage}
              noWrap
            />
          ))
        : null}
      {messages ? (
        <MessageItem
          className={styles.MessageItem}
          message={viewMessage.messageText}
          type={viewMessage.noticeType}
          subject={viewMessage.noticeTitle}
          onClick={handleOpenMessenger}
          hasViewed={!unread}
          isImage={viewMessage.isImage}
          noWrap
        />
      ) : (
        <InfoMessageBlock
          title="No Messages"
          description="When a tenancy is set up a messaging channel will appear here"
        />
      )}
      {isOpen ? (
        <Modal onClose={handleCLose} scrollContainer noPadding fullHeight>
          <Messaging message={messages} onClose={handleCLose} />
        </Modal>
      ) : null}
      {isOpenNotice ? (
        <Modal
          onClose={handleCLose}
          title="Notice"
          showCloseButton
          scrollContainer
          noPadding
        >
          <NoticeView notice={isOpenNotice} />
        </Modal>
      ) : null}
    </div>
  );
};

TenancyViewNotices.displayName = 'TenancyViewNotices';

export default observer(TenancyViewNotices);
